import React from 'react';
import { Card, CardContent, Typography, Divider, Grid, Paper, Box, Button } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import EventIcon from '@mui/icons-material/Event';
import BadgeIcon from '@mui/icons-material/Badge';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PrintIcon from '@mui/icons-material/Print';
import { printFichaSocio } from '../utils/printHelpers';

const InfoItem = ({ icon, label, value }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
    <Box sx={{ color: 'text.secondary', mr: 1, display: 'flex' }}>
      {icon}
    </Box>
    <Box>
      <Typography variant="body2" color="text.secondary">
        {label}:
      </Typography>
      <Typography variant="body1">
        {value || 'N/A'}
      </Typography>
    </Box>
  </Box>
);

const AfiliadoInfo = ({ afiliado, onVerCtaCte }) => {
  if (!afiliado) return null;

  return (
    <Card sx={{ mb: 3, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center' }}>
          <PersonIcon sx={{ mr: 1 }} />
          Información del Afiliado
        </Typography>
        <Divider sx={{ mb: 2 }} />
        
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <InfoItem 
              icon={<PersonIcon fontSize="small" />}
              label="Nombre"
              value={afiliado.nombre}
            />
            <InfoItem 
              icon={<BadgeIcon fontSize="small" />}
              label="DNI"
              value={afiliado.dni}
            />
           
            
          </Grid>
          <Grid item xs={12} md={6}>
            <InfoItem 
              icon={<EventIcon fontSize="small" />}
              label="Fecha de Alta"
              value={afiliado.fecha_afiliacion}
            />
            <InfoItem 
              icon={<PersonIcon fontSize="small" />}
              label="Titular"
              value={afiliado.nombre_titular}
            />
          </Grid>
          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ p: 0.1, bgcolor: 'grey.50' }}>
              <Typography variant="subtitle2" color="text.secondary">Categoría:</Typography>
              <Typography>{afiliado.categoria}</Typography>
            </Paper>
            <Paper variant="outlined" sx={{ p: 0.5, bgcolor: 'moccasin'  }}>
              <Typography variant="subtitle2" color="text.secondary">Plan:</Typography>
              <Typography>{afiliado.plan}</Typography>
            </Paper>            
          </Grid>
          <Grid item xs={12}>
            <Paper variant="outlined" sx={{ p: 1, bgcolor: 'grey.50' }}>
              <Typography variant="subtitle2" color="text.secondary">F. Vigencia:</Typography>
              <Typography>{afiliado.fecvigencia}</Typography>
              <Typography variant="subtitle2" color="text.secondary">N° Afiliado:</Typography>
              <Typography>{afiliado.id_afiliado}</Typography>
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                mt: 1.5,
                flexWrap: 'wrap',
                gap: 1
              }}>
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  color: afiliado.estado === 'A' ? 'success.main' : 'error.main',
                  fontWeight: 'bold'
                }}>
                  {afiliado.estado === 'A' ? (
                    <CheckCircleIcon sx={{ mr: 0.5 }} />
                  ) : (
                    <CancelIcon sx={{ mr: 0.5 }} />
                  )}
                  <Typography variant="body2">
                    {afiliado.estado === 'A' ? 'ACTIVO' : 'DE BAJA'}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<PrintIcon />}
                    onClick={() => printFichaSocio(afiliado)}
                    sx={{ 
                      textTransform: 'none',
                      borderColor: 'primary.main',
                      color: 'primary.main',
                      '&:hover': {
                        borderColor: 'primary.dark',
                        bgcolor: 'rgba(25, 118, 210, 0.04)'
                      }
                    }}
                  >
                    Imprimir Ficha
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    startIcon={<AccountBalanceWalletIcon />}
                    onClick={() => onVerCtaCte && onVerCtaCte(afiliado.id_afiliado)}
                    sx={{ 
                      textTransform: 'none',
                      bgcolor: 'primary.main',
                      boxShadow: 1,
                      '&:hover': {
                        bgcolor: 'primary.dark',
                        boxShadow: 2
                      }
                    }}
                  >
                    Ver Cuenta Corriente
                  </Button>
                </Box>
              </Box>
            </Paper>
        
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AfiliadoInfo;
